// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2yDIX","colCheckbox":"styles_colCheckbox__3nzTA"};